import React, { lazy } from "react";
import AccessMiddleware from "./middleware/auth/AccessMiddleware";
import { CORE_RAW_ORDER } from "../utils/constants/routeConstant";
import { LoadablePage } from "app/utils/loadablePage";

// 🔁 Lazy-loaded components
const CoreInventoryList = lazy(() => import("app/pages/Inventory/Core Inventory/ListCore"));
const AddCoreStock = lazy(() => import("app/pages/Inventory/Core Inventory/AddCore"));
const EditCoreStock = lazy(() => import("app/pages/Inventory/Core Inventory/EditCore"));
const ViewDetails = lazy(() => import("app/pages/Inventory/Core Inventory/ListCore/Approval/ViewDetails"));
const IssueRawOrderCore = lazy(() => import("app/pages/Inventory/Core Inventory/IssueRawOrder"));

export const coreInventoryRoute = [
  {
    middleware: [
      {
        element: AccessMiddleware,
        fallbackPath: ["/dashboard", "core_inventory", "view"],
      },
    ],
    routes: [
      {
        path: "/inventory/core",
        element: LoadablePage(CoreInventoryList),
      },
      {
        path: "/inventory/core/add",
        element: LoadablePage(AddCoreStock),
      },
      {
        path: "/inventory/core/edit",
        element: LoadablePage(EditCoreStock),
      },
      {
        path: "/inventory/core-approval/view-details/:id/:invoiceId",
        element: LoadablePage(ViewDetails),
      },
      {
        path: CORE_RAW_ORDER,
        element: LoadablePage(IssueRawOrderCore),
      },
    ],
  },
];
